/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UnhideMcpServerRequestBody = {
  /**
   * The MCP server.
   */
  mcpServerId: string;
};

/** @internal */
export type UnhideMcpServerRequestBody$Outbound = {
  mcp_server_id: string;
};

/** @internal */
export const UnhideMcpServerRequestBody$outboundSchema: z.ZodMiniType<
  UnhideMcpServerRequestBody$Outbound,
  UnhideMcpServerRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function unhideMcpServerRequestBodyToJSON(
  unhideMcpServerRequestBody: UnhideMcpServerRequestBody,
): string {
  return JSON.stringify(
    UnhideMcpServerRequestBody$outboundSchema.parse(unhideMcpServerRequestBody),
  );
}
